import ReactDOM from "react-dom/client";
import "./src/styles/style.scss";

/**
 *
 * https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#replaceHydrateFunction
 */
export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};
